import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GoogleAnalytics = forwardRef<SVGSVGElement, IconProps>(({ color, size = 20 }, forwardedRef) => {
  const width = Math.round(size * (18 / 20))
  if (color) {
    return (
      <svg width={width} height={size} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3824_233)">
          <path
            d="M17.3341 16.8658C17.3341 18.1129 16.3147 19.1645 15.0598 19.1645H14.7844C13.6081 19.0089 12.7453 17.9568 12.7847 16.7879V3.22826C12.7453 2.05917 13.6081 1.04572 14.7844 0.851412C16.0393 0.696514 17.1765 1.59173 17.3341 2.8384V16.8658Z"
            fill={color}
          />
          <path
            d="M2.9421 14.6444C3.39192 14.6444 3.83163 14.7769 4.20564 15.0252C4.57964 15.2736 4.87115 15.6265 5.04328 16.0394C5.21542 16.4524 5.26046 16.9068 5.1727 17.3451C5.08495 17.7835 4.86834 18.1862 4.55028 18.5022C4.23221 18.8183 3.82697 19.0335 3.3858 19.1207C2.94463 19.2079 2.48734 19.1631 2.07176 18.9921C1.65619 18.821 1.30099 18.5314 1.05109 18.1598C0.801186 17.7881 0.667801 17.3512 0.667801 16.9042C0.628641 15.6573 1.68722 14.6444 2.9421 14.6444ZM8.94164 7.74756C7.68651 7.82563 6.7075 8.87749 6.7075 10.1244V16.242C6.7075 17.8783 7.45255 18.8915 8.51113 19.1252C9.76626 19.3592 10.9426 18.5797 11.2169 17.3328C11.2561 17.1771 11.2561 17.0212 11.2561 16.8653V10.0466C11.2561 8.79942 10.2367 7.74756 8.9818 7.74756H8.94164Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_3824_233">
            <rect width="16.6667" height="18.3333" fill="white" transform="translate(0.666748 0.833496)" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      width={width}
      height={size}
      style={{ width, height: size }}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_3824_233)">
        <path
          d="M17.3341 16.8658C17.3341 18.1129 16.3147 19.1645 15.0598 19.1645H14.7844C13.6081 19.0089 12.7453 17.9568 12.7847 16.7879V3.22826C12.7453 2.05917 13.6081 1.04572 14.7844 0.851412C16.0393 0.696514 17.1765 1.59173 17.3341 2.8384V16.8658Z"
          fill="#F9AB00"
        />
        <path
          d="M2.9421 14.6444C3.39192 14.6444 3.83163 14.7769 4.20564 15.0252C4.57964 15.2736 4.87115 15.6265 5.04328 16.0394C5.21542 16.4524 5.26046 16.9068 5.1727 17.3451C5.08495 17.7835 4.86834 18.1862 4.55028 18.5022C4.23221 18.8183 3.82697 19.0335 3.3858 19.1207C2.94463 19.2079 2.48734 19.1631 2.07176 18.9921C1.65619 18.821 1.30099 18.5314 1.05109 18.1598C0.801186 17.7881 0.667801 17.3512 0.667801 16.9042C0.628641 15.6573 1.68722 14.6444 2.9421 14.6444ZM8.94164 7.74756C7.68651 7.82563 6.7075 8.87749 6.7075 10.1244V16.242C6.7075 17.8783 7.45255 18.8915 8.51113 19.1252C9.76626 19.3592 10.9426 18.5797 11.2169 17.3328C11.2561 17.1771 11.2561 17.0212 11.2561 16.8653V10.0466C11.2561 8.79942 10.2367 7.74756 8.9818 7.74756H8.94164Z"
          fill="#E37400"
        />
      </g>
      <defs>
        <clipPath id="clip0_3824_233">
          <rect width="16.6667" height="18.3333" fill="white" transform="translate(0.666748 0.833496)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default GoogleAnalytics
